module.exports = __webpack_public_path__ + "static/media/sasha_anon.6ba19561.png";